export const isClientSide =
    typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
